// extracted by mini-css-extract-plugin
module.exports = {"midi__header":"midi_midi__header__T1bpd","midi__tag-view":"midi_midi__tag-view__sBLVC","midi__trending":"midi_midi__trending__2W1uu"};